import { render, staticRenderFns } from "./update.vue?vue&type=template&id=463de3d2&scoped=true"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"
import style0 from "./update.vue?vue&type=style&index=0&id=463de3d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463de3d2",
  null
  
)

export default component.exports